/**
 * question
 */

/**
 * uint32 Type = 3; // 题目类型：1单选/2多选/3判断/4填空/5问答/6编程(OJ)
 */
const questionType = {
  code: { key: 'code', value: 7, label: '编程(OJ)' },
};

/**
 * uint32 Subject = 2; // 科目：1计算机
 */
const questionSubject = {
  it: { key: 'it', value: 1, label: '计算机' },
};

const testStatus = {
  UNKNOWN_STATUS: { label: '未知状态', key: 'UNKNOWN_STATUS' },
  STATUS_READY: { label: '准备状态', key: 'STATUS_READY' },
  STATUS_SEND_SUCC: { label: '发送请求成功', key: 'STATUS_SEND_SUCC' },
  STATUS_SEND_FAILED: { label: '发送请求失败', key: 'STATUS_SEND_FAILED' },
  STATUS_PASSED: { label: '测试通过', key: 'STATUS_PASSED' },
  STATUS_FAILED: { label: '测试不通过', key: 'STATUS_FAILED' },
}

export default {
  questionType,
  questionSubject,
  testStatus,
  getCacheCodeKey: (userId, examId, questionId, examGradeId) => `${userId}_${examId}-${questionId}-${examGradeId}`
};
